import { useSubscribeToCopilotChannel } from 'copilot-toolkit/channel/hooks/useSubscribeToCopilotChannel';
const IframeSpecificChannelListener = ({
  enableAppRender
}) => {
  useSubscribeToCopilotChannel('SEND_ACTION', enableAppRender);
  useSubscribeToCopilotChannel('SEND_MESSAGE', enableAppRender);
  useSubscribeToCopilotChannel('LAUNCH_FROM_COPILOT_PREVIEW', enableAppRender);
  useSubscribeToCopilotChannel('LAUNCH_WITH_CUSTOM_COPILOT', enableAppRender);
  useSubscribeToCopilotChannel('PROMPT_USER_FOR_MORE_INFO', enableAppRender);
  useSubscribeToCopilotChannel('OPEN_COPILOT', enableAppRender);
  return null;
};
export default IframeSpecificChannelListener;